import React from 'react';
import { projects } from '../mock';
import { ExternalLink, Github } from 'lucide-react';

const Projects = () => {
  return (
    <div className="page-container projects-page">
      <div className="page-header">
        <h1 className="page-title">
          <span className="text-amber">[</span>
          PROJECTS
          <span className="text-amber">]</span>
        </h1>
        <div className="ascii-line">
          {'━'.repeat(60)}
        </div>
        <p className="page-subtitle text-muted">
          # Open source tools and personal projects
        </p>
      </div>

      <div className="projects-content">
        <pre className="command-output">
{`$ git clone https://github.com/titagram/*
Cloning into repositories...
Receiving objects: 100% (1/1), done.
`}
        </pre>

        <div className="projects-grid">
          {projects.map((project) => (
            <div key={project.id} className="project-card">
              <div className="project-header">
                <h3 className="project-name">
                  <span className="text-cyan">$</span> {project.name}
                </h3>
                <div className="project-links">
                  <a 
                    href={project.github} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="project-link"
                    title="View on GitHub"
                  >
                    <Github size={20} />
                  </a>
                </div>
              </div>

              <div className="project-body">
                <p className="project-description">
                  {project.description}
                </p>

                <div className="project-tech">
                  <div className="tech-label text-muted">Tech Stack:</div>
                  <div className="tech-tags">
                    {project.tech.map((tech, index) => (
                      <span key={index} className="tech-tag">
                        <span className="text-amber">●</span> {tech}
                      </span>
                    ))}
                  </div>
                </div>
              </div>

              <div className="project-footer">
                <a 
                  href={project.github}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="project-button"
                >
                  <span>git clone</span>
                  <ExternalLink size={16} />
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="projects-placeholder">
          <div className="placeholder-box">
            <pre className="placeholder-art">
{`
 ╔════════════════════════════════════════╗
 ║                                        ║
 ║   More projects coming soon...         ║
 ║   Visit my GitHub profile              ║
 ║   for the latest updates               ║
 ║                                        ║
 ╚════════════════════════════════════════╝
`}
            </pre>
          </div>
        </div>
      </div>

      <div className="terminal-hint-bottom">
        <span className="text-muted">
          # Terminal command: type 'cat projects' to list all projects
        </span>
      </div>
    </div>
  );
};

export default Projects;